import moment from 'moment';
import React from 'react';

export default function WeekHeader() {
  return (
    <div className='event-calendar-header-week'>
      {moment.weekdaysShort().map((label) => (
        <div className={`echw-label echw-label-${label.toLowerCase()}`} key={`echw-label-${label}`}>
          {label}
        </div>
      ))}
    </div>
  );
}
